<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!ocultarFooter"></app-footer>
<ngx-scrolltop></ngx-scrolltop>
<!-- <app-sidebar></app-sidebar>
<app-righbar></app-righbar> -->